<template>
    <div class="my-balance">
        <div class="my-asset" v-loading="assets_processing">
            <Balance v-for="asset in assets" :key="asset.asset_name" :asset="asset" :selected_asset_name="selected_asset_name" :onSelect="onSelect"/>
        </div>
        <div class="my-asset-history" v-show="selected_asset_name" v-loading="assets_processing">
            <BalanceHistory v-if="selected_asset_name" :selected_asset_name="selected_asset_name" />
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import Balance from "@/components/Balance";
import BalanceHistory from "@/components/BalanceHistory";

export default {
    name: "MyBalance",
    components: {
        Balance,
        BalanceHistory
    },
    data() {
        return {
            assets:[],
            asset_history: [],
            assets_processing: false,
            asset_history_processing: false,
            selected_asset_name: null,
        };
    },
    mounted(){
        this.loadData();
    },
    methods: {
        ...mapActions(["request", "getError"]),
        loadData() {
            let ctrl = this;
            ctrl.assets_processing = true;
            ctrl.request({
                method: "GET",
                endpoint: "my/balance/my",
            })
                .then(({ data = {} }) => {
                    ctrl.assets = data.assets;
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    setTimeout(() => {
                        ctrl.assets_processing = false;
                    }, 500);
                });
        },
        onSelect(asset_name = null) {
            this.selected_asset_name = asset_name;
            if(asset_name) {
                this.loadHistoryData(asset_name);
            }
        },
        loadHistoryData(asset_name) {
            let ctrl = this;
            ctrl.asset_history_processing = true;
            ctrl.request({
                method: "GET",
                endpoint: `my/balance/history/${asset_name}`,
            })
                .then(({ data = {} }) => {
                    ctrl.asset_history = data.results
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    setTimeout(() => {
                        ctrl.asset_history_processing = false;
                    }, 500);
                });
        },
    }
};
</script>

<style scoped>
.my-balance {
    display: flex;
    height: 100%;
}

.my-asset {
    width: 340px;
    background-color: #0079b7;
    color: #fff;
        border-right: 1px solid rgba(255,255,255,0.1);
}
.my-asset-history {
    width: calc(100% - 340px);
    background-color: #eee;
    color: #444;
    border-right: 1px solid rgba(255,255,255,0.1);
    overflow: auto;
}
</style>
